import { ISearchBar } from '../state';
import {
  FlightSearchBarActionType,
  FlightSearchBarActions,
  IFlightSearchBarState,
} from '../types/flight';

export const flightReducer = (
  state: ISearchBar,
  action: FlightSearchBarActions
): { flight: IFlightSearchBarState } => {
  const { type, payload } = action;

  switch (type) {
    case FlightSearchBarActionType.SET_START_DATE:
      return {
        flight: {
          ...state.flight,
          startDate: payload,
        },
      };

    case FlightSearchBarActionType.SET_END_DATE:
      return {
        flight: {
          ...state.flight,
          endDate: payload,
        },
      };

    case FlightSearchBarActionType.SET_GUESTS:
      return {
        flight: {
          ...state.flight,
          guestInfo: payload,
        },
      };

    case FlightSearchBarActionType.SET_ARRIVAL_AIRPORT:
      return {
        flight: {
          ...state.flight,
          arrivalAirport: payload,
        },
      };

    case FlightSearchBarActionType.SET_DEPARTURE_AIRPORT:
      return {
        flight: {
          ...state.flight,
          departureAirport: payload,
        },
      };

    case FlightSearchBarActionType.SET_IS_ONE_WAY:
      return {
        flight: {
          ...state.flight,
          isOneWay: payload,
          ...(payload && { endDate: null }),
        },
      };

    case FlightSearchBarActionType.SET_IS_DIRECT_FLIGHT:
      return {
        flight: {
          ...state.flight,
          isDirectFlight: payload,
        },
      };
    case FlightSearchBarActionType.SET_IS_VALID_FLIGHT_SEARCH_BAR:
      return {
        flight: {
          ...state.flight,
          isValidFlightSearchBar: payload,
        },
      };

    case FlightSearchBarActionType.SET_IS_SUBMIT:
      return {
        flight: {
          ...state.flight,
          isSubmit: payload,
        },
      };

    case FlightSearchBarActionType.SET_CABIN_CLASS:
      return {
        flight: {
          ...state.flight,
          cabinClass: payload,
        },
      };

    case FlightSearchBarActionType.SET_ALL:
      return {
        flight: {
          ...state.flight,
          ...payload,
        },
      };

    case FlightSearchBarActionType.SET_IS_DRAWER_OPEN:
      return {
        flight: {
          ...state.flight,
          isDrawerOpen: payload,
        },
      };
    case FlightSearchBarActionType.SET_IS_ARRIVAL_ERROR:
      return {
        flight: {
          ...state.flight,
          isArrivalError: payload,
        },
      };
    case FlightSearchBarActionType.SET_IS_DEPARTURE_ERROR:
      return {
        flight: {
          ...state.flight,
          isDepartureError: payload,
        },
      };

    default:
      return {
        flight: {
          ...state.flight,
        },
      };
  }
};
